import React, { FC } from 'react';
import { SortOrder } from 'antd/lib/table/interface';
import { useTranslation } from 'react-i18next';
import {
  NameColumn,
  TypeColumn,
  Header,
  LeftColumnsCont,
  ParticipantsColumn,
  ArrowUpIcon,
  ArrowDownIcon,
  ArrowsCont,
} from './ReportsSetupTableHeader.styles';
import { useSort } from '../../../hooks';

interface IReportsSetupTableHeader {
  appliedSort: string | (string | null)[] | null;
  sort: (sorter: { field: string; order: SortOrder }) => void;
  isEffectSurvey: boolean;
}

const ReportsSetupTableHeader: FC<IReportsSetupTableHeader> = ({
  appliedSort,
  sort,
  isEffectSurvey,
}) => {
  const { t } = useTranslation();
  const { divideAppliedSort, getFieldOrder } = useSort();

  const handleSort = () => {
    if (Array.isArray(appliedSort)) return;

    sort({
      field: 'name',
      order: getFieldOrder(
        'name',
        // @ts-ignore
        divideAppliedSort(!appliedSort || appliedSort === 'name:desc' ? 'name:asc' : 'name:desc')
      ) as SortOrder,
    });
  };

  return (
    <Header id="Header">
      <LeftColumnsCont id="LeftColumnsCont">
        <NameColumn id="NameColumn">
          {t('viewSurvey.reportsSetup.name')}
          <ArrowsCont onClick={handleSort}>
            <ArrowUpIcon isActive={appliedSort === 'name:asc'} />
            <ArrowDownIcon isActive={appliedSort === 'name:desc'} />
          </ArrowsCont>
        </NameColumn>
        {isEffectSurvey ? null : (
          <TypeColumn id="TypeColumn">{t('viewSurvey.reportsSetup.type')}</TypeColumn>
        )}

        <ParticipantsColumn isEffectSurvey={isEffectSurvey} id="ParticipantsColumn">
          {t('viewSurvey.reportsSetup.participants.participants')}
        </ParticipantsColumn>
      </LeftColumnsCont>
    </Header>
  );
};

export default ReportsSetupTableHeader;
